module.exports = __webpack_public_path__ + "assets/images/icon_yellow.daccdb6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/icon_yellow.png
// module id = 745
// module chunks = 1